import React from 'react';
import T from './modules/translation';

function ViewMode(props) {
  return (
    <div className="view-mode-container mt-4 ms-2" onChange={props.onChange}>
      <div className="form-check form-check-inline me-3">
        <input className="form-check-input" type="radio" id="visits" name="viewMode"
          value="visits"
          defaultChecked={true}
          data-toggle="tooltip"
          data-placement="bottom"
          data-trigger="hover"
          title={T.get("winRate") + "/" + T.get("visits")} />
        <label htmlFor="visits" className="form-check-label">
          <span className="view-mode-text">%</span>
        </label>
      </div>
      <div className="form-check form-check-inline me-3">
        <input className="form-check-input" type="radio" id="variation" name="viewMode"
          value="variation"
          data-toggle="tooltip"
          data-placement="bottom"
          data-trigger="hover"
          title={T.get("variation")} />
        <label htmlFor="variation" className="form-check-label">
          <span className="view-mode-text">V</span>
        </label>
      </div>
      <div className="form-check form-check-inline me-3">
        <input className="form-check-input" type="radio" id="moveNumber" name="viewMode"
          value="moveNumber"
          data-toggle="tooltip"
          data-placement="bottom"
          data-trigger="hover"
          title={T.get("moveNumber")} />
        <label htmlFor="moveNumber" className="form-check-label">
          <span className="view-mode-text">{"\u2460"}</span>
        </label>
      </div>
      <div className="form-check form-check-inline me-3">
        <input className="form-check-input" type="radio" id="none" name="viewMode"
          value="none"
          data-toggle="tooltip"
          data-placement="bottom"
          data-trigger="hover"
          title={T.get("viewModeNone")} />
        <label htmlFor="none" className="form-check-label">
          <span className="view-mode-text">{"\u2205"}</span>
        </label>
      </div>
    </div>
  );
}

export default ViewMode;